import { configConstants } from '../constants';

const initialState = {
    loading: false,
    appconfigs: [],
    error: null
};

const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case configConstants.FETCH_APPCONFIGS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case configConstants.FETCH_APPCONFIGS_SUCCESS:
            return {
                ...state,
                appconfigs: action.appconfigs,
                loading: false
            };
        case configConstants.FETCH_APPCONFIGS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        default:
            return state;
    }
};

export default configReducer;
